export const Validity = { CURRENT: 1, FUTURE: 2, PAST: 3 };
Object.freeze(Validity);
